import config from '../config';

export const SET_PLAN_LAYER_WEIGHT = 'SET_PLAN_LAYER_WEIGHT';
export const SET_PLAN_OPACITY = 'SET_PLAN_OPACITY';

export const setPlanLayerWeight = (id, value) => ({ type: SET_PLAN_LAYER_WEIGHT, payload: { id, value } });
export const setPlanOpacity = (id, value) => ({ type: SET_PLAN_OPACITY, payload: { id, value } });

export const getPlan = (state) => state.plan;

const initialState = config.plan;

const findLayer = (state, id) => state.layers.find((layer) => layer.id === id);

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_PLAN_LAYER_WEIGHT:
      findLayer(state, payload.id).weight = payload.value;
      return;
    case SET_PLAN_OPACITY:
      state.opacity = payload.value;
      return;
    default:
      return state;
  }
};
